import { Injectable, Injector } from "@angular/core";
import { Art57NodeList } from "../Art57NodeList";
import { ListView } from "../../../Data/ListView";

@Injectable({
  providedIn: 'root',
})
export class TreeNodeImportedMessagesList extends Art57NodeList {
  constructor(injector: Injector) {
    super(injector, new ListView(), 'Imported Messages ({param})');
    this.expanded = true;
    this.labelNodeName = "Imported Messages";
  }

  override refreshLabel(): void {
    if (this.children && this.children.length === 0) {
      this.label = this.labelNodeName;
    } else {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  }

  override getHeaders(): string[] {
    return ['Message Type', 'Message Number', 'Message Date'];
  }

  reset() {
    while (this.children!.length > 0) {
      this.children!.pop();
    }
    this.data.model = null;
    this.refreshLabel();
    this.data.model = {};
  }

}